import { FC, FocusEvent, FormEvent } from 'react'
import { FieldProps } from 'formik'
import { SearchInputField } from '@components-v2/atoms/SearchInputField'
import classNames from 'classnames'
import styles from './index.module.scss'

type Props = {
  placeholder?: string
  testid?: string
  customBlurHandler?: (e: FocusEvent<HTMLInputElement>) => void
  customChangeHandler?: (e: FormEvent<HTMLInputElement>) => void
  supportingText?: string
  fullWidth?: boolean
}

export const SearchInputFieldGroup: FC<Props & FieldProps<never>> = ({
  field,
  placeholder = '',
  testid,
  customBlurHandler,
  customChangeHandler,
  fullWidth = false,
}) => {
  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    field.onBlur(e)

    if (customBlurHandler) {
      customBlurHandler(e)
    }
  }

  return (
    <div className={classNames(styles.container, { [styles.fullWidth]: fullWidth })}>
      <SearchInputField
        placeholder={placeholder}
        name={field.name}
        testid={testid}
        value={field.value}
        onChange={customChangeHandler || field.onChange}
        onBlur={onBlur}
        fullWidth={fullWidth}
      />
    </div>
  )
}
